export const environment = {
  name: 'staging',
  production: false,
  useMock: true,
  showDevelopmentScreens: false
};
